import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../Theme/theme';

const { colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	root: {
		alignItems: 'center',
		borderRadius: THEME.common.borderRadius,
		borderStyle: 'solid',
		borderWidth: 1,
		boxSizing: 'border-box',
		color: colors.text.dark,
		display: 'grid',
		fontFamily: typography.fontFamilies.lexend,
		fontSize: typography.fontSizes.sm,
		gridTemplateAreas: '"icon title actions" "icon description actions"',
		gridTemplateColumns: 'auto minmax(0, 1fr) auto',
		lineHeight: 1.4,
		padding: `${SPACE[12]}px ${SPACE[16]}px`,
		[THEME.queries.sm]: {
			gridTemplateAreas: '"icon title" "icon description" "icon actions"',
			gridTemplateColumns: 'auto minmax(0, 1fr)',
		},
	},
	icon: {
		alignItems: 'center',
		alignSelf: 'center',
		display: 'inline-flex',
		gridArea: 'icon',
		marginRight: SPACE[12],
	},
	title: {
		alignSelf: 'flex-end',
		fontWeight: typography.fontWeights.bold,
		gridArea: 'title',
		margin: 0,
		':has(+ [data-slot="alert-description"])': {
			marginBottom: SPACE[4],
		},
	},
	description: {
		alignSelf: 'flex-start',
		color: colors.text.main,
		gridArea: 'description',
		margin: 0,
	},
	actions: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[8],
		gridArea: 'actions',
		marginLeft: SPACE[16],
		[THEME.queries.sm]: {
			marginLeft: 0,
			marginTop: SPACE[8],
		},
	},
});

export const toneStyles = StyleSheet.create({
	info: {
		background: colors.primary.light,
		borderColor: colors.primary.main,
	},
	success: {
		background: colors.success.light,
		borderColor: colors.success.main,
	},
	warning: {
		background: colors.warning.light,
		borderColor: colors.warning.main,
	},
	danger: {
		background: colors.danger.light,
		borderColor: colors.danger.main,
	},
});

export const toneIconStyles = StyleSheet.create({
	info: { color: colors.primary.main },
	success: { color: colors.success.dark },
	warning: { color: colors.warning.dark },
	danger: { color: colors.danger.dark },
});
